import { CREATE_AGENDA_ACTION, STATUS } from "../constant";

const initState = {
  pageInfo: null
};
export default function createAgendaReducer(state = initState, action) {
  switch (action.type) {
    case CREATE_AGENDA_ACTION.LOAD_PAGE_INFO_START:
      return { ...state, loadPageInfoStatus: STATUS.LOADING };
    case CREATE_AGENDA_ACTION.LOAD_PAGE_INFO_SUCCESS:
      return {
        ...state,
        pageInfo: action.payload,
        loadPageInfoStatus: STATUS.SUCCESS
      };
    case CREATE_AGENDA_ACTION.LOAD_PAGE_INFO_FAILURE:
      return { ...state, loadPageInfoStatus: STATUS.ERROR };

    default:
      return state;
  }
}
